import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

/**
 * Redirect component for /register in immersive theme
 * Redirects to homepage with signup tab active
 */
export default function ImmersiveRegisterRedirect() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Redirect to homepage with signup tab active
    navigate('/', { 
      state: { 
        tab: 'auth',
        from: location.state?.from // Preserve original redirect target
      },
      replace: true 
    })
  }, [navigate, location])

  return null
}
